<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
    <div class="ep-header-bar d-flex align-items-center border-bottom px-4">
        <button
            [cSidebarToggle]="sidebarId()"
            cHeaderToggler
            class="ep-toggle-btn"
            toggle="visible"
            aria-label="Toggle sidebar navigation"
        >
            <svg cIcon name="cilMenu" size="lg"></svg>
        </button>

        <div class="ep-breadcrumb-wrap">
            <app-breadcrumb />
        </div>

        <div class="ep-header-right ms-auto d-flex align-items-center">
            <c-header-nav class="ep-header-item">
                <ng-container *ngTemplateOutlet="messageDropdown" />
            </c-header-nav>

            <c-header-nav class="ep-header-item">
                <ng-container *ngTemplateOutlet="languageDropdown" />
            </c-header-nav>

            <c-header-nav class="ep-header-item">
                <button
                    type="button"
                    class="ep-role-btn"
                    (click)="switchRole()"
                    aria-label="Change role"
                    title="Change role"
                >
                    <svg viewBox="0 0 16 16" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 5H12M12 5L9 2M12 5L9 8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M14 11H4M4 11L7 8M4 11L7 14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </c-header-nav>
        </div>
    </div>
</ng-container>
<ng-template #userDropdown>
    <c-dropdown [popperOptions]="{ placement: 'bottom-start' }" variant="nav-item">
        <button [caret]="false" cDropdownToggle class="ep-avatar-btn py-0 pe-0" aria-label="Open user menu">
            <span class="ep-avatar-chip">
                {{ userInitials }}
                <span class="ep-avatar-status"></span>
            </span>
        </button>
        <ul cDropdownMenu class="pt-0 w-auto user-dropdown" [ngClass]="{'user-dropdown-personal': user.user_type?.includes('Personal')}">
            <li>
                <a cDropdownItem routerLink="/profile">
                    <svg cIcon class="me-2" name="cilUser"></svg>Profile
                </a>
            </li>
            <li>
                <a cDropdownItem style="cursor: pointer" (click)="switchRole()">
                    <svg cIcon class="me-2" name="cilUser"></svg>Switch Role
                </a>
            </li>
            <li *ngIf="!user.is_super_admin && user.is_company_admin && user.user_type === 'Buyer'">
                <a cDropdownItem routerLink="/subscription">
                    <svg cIcon class="me-2" name="cilSpreadsheet"></svg>{{ 'subscription.title' | translate }}
                </a>
            <li>
                <a cDropdownItem style="cursor: pointer" (click)="logout()">
                    <svg cIcon class="me-2" name="cilAccountLogout"></svg>Logout
                </a>
            </li>
        </ul>
    </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle aria-label="Open theme picker">
      <svg cIcon [name]="icons()" size="lg"></svg>
    </button>
    <div cDropdownMenu>
      @for (mode of colorModes; track mode.name) {
        <button
          (click)="colorMode.set(mode.name)"
          [active]="colorMode()===mode.name"
          cDropdownItem
          class="d-flex align-items-center"
        >
          <svg cIcon class="me-2" [name]="mode.icon" size="lg"></svg>
          {{ mode.text }}
        </button>
      }
    </div>
  </c-dropdown>
</ng-template>

<ng-template #languageDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle class="ep-language-btn" aria-label="Open language picker">
      {{ selectedLanguage | uppercase }}
    </button>
    <div cDropdownMenu class="ep-lang-menu">
      @for (language of languages; track language.name) {
        <button
          (click)="setLanguage(language.name)"
          [active]="language.name == selectedLanguage"
          cDropdownItem
          class="ep-lang-item d-flex align-items-center"
        >
          {{ language.text }}
        </button>
      }
    </div>
  </c-dropdown>
</ng-template>

<ng-template #messageDropdown>
    <c-dropdown alignment="end" variant="nav-item">
        <button [caret]="false" cDropdownToggle cButton class="ep-alerts-btn">
            <span class="ep-alerts-dot" *ngIf="newNotificationAvailable"></span>
            <span class="ep-alerts-count" *ngIf="newNotificationAvailable">{{ 'header.alertsCount'|translate:{ count: newNotificationCount } }}</span>
            <svg cIcon name="cilBell" size="lg" *ngIf="!newNotificationAvailable"></svg>
        </button>
        <div cDropdownMenu class="ep-notif-menu">
        @for (notification of notifications; track notification.id) {
        <a href={{notification.link}}
   cDropdownItem
   class="ep-notif-item"
   [ngClass]="{ 'ep-notif-item-unread': !notification.is_read }"
   (click)="setNotificationStatus(notification)">
    <span class="ep-notif-dot" *ngIf="!notification.is_read"></span>
    <p class="ep-notif-text">{{notification.message | translate}}</p>
</a>
        }
        <a routerLink="/system-notifications/{{user.id}}" class="ep-notif-footer">
            <div cDropdownItem class="d-flex align-items-center justify-content-center">
            <p class="ep-notif-footer-text m-0">{{'systemNotifications.viewAllMessages' | translate}}</p>
            </div>
        </a>
        </div>
    </c-dropdown>
</ng-template>